import { render, staticRenderFns } from "./SUB001M01.vue?vue&type=template&id=6e5809b8&"
import script from "./SUB001M01.vue?vue&type=script&lang=js&"
export * from "./SUB001M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports